import { Button } from "@/components/ui/button";
import { Plus, Minus } from "lucide-react";
import { Event } from "@/lib/types";

interface StandingTicketsProps {
  event: Event;
  standingTickets: number;
  maxStandingTickets: number;
  earlyBirdTickets: number;
  maxEarlyBirdTickets: number;
  onStandingTicketChange: (increment: boolean) => void;
  onEarlyBirdTicketChange: (increment: boolean) => void;
}

export const StandingSection = ({
  event,
  standingTickets,
  maxStandingTickets,
  earlyBirdTickets,
  maxEarlyBirdTickets,
  onStandingTicketChange,
  onEarlyBirdTicketChange,
}: StandingTicketsProps) => {
  return (
    <div className="space-y-8">
      <div className="grid gap-6">
        {/* Early Bird Section */}
        {event.early_bird_price && event.early_bird_price > 0 && (
          <div className="bg-gray-700 p-6 rounded-lg">
            <div className="flex flex-col space-y-4">
              <div className="flex flex-col md:flex-row md:justify-between md:items-center">
                <div>
                  <h3 className="text-2xl font-bold text-white">Early Bird</h3>
                  {event.ticket_description_early_bird && (
                    <p className="text-gray-400 italic mt-1">{event.ticket_description_early_bird}</p>
                  )}
                </div>
                <div className="flex items-center gap-4 mt-4 md:mt-0">
                  <span className="text-2xl font-bold text-white">${event.early_bird_price}</span>
                  <div className="flex items-center gap-4">
                    <Button
                      variant="outline"
                      size="icon"
                      onClick={() => onEarlyBirdTicketChange(false)}
                      disabled={earlyBirdTickets === 0}
                    >
                      <Minus className="h-4 w-4" />
                    </Button>
                    <span className="text-2xl font-bold text-white min-w-[3ch]">
                      {earlyBirdTickets}
                    </span>
                    <Button
                      variant="outline"
                      size="icon"
                      onClick={() => onEarlyBirdTicketChange(true)}
                      disabled={!maxEarlyBirdTickets || earlyBirdTickets >= maxEarlyBirdTickets}
                    >
                      <Plus className="h-4 w-4" />
                    </Button>
                  </div>
                </div>
              </div>
              {maxEarlyBirdTickets === 0 && (
                <p className="text-sm text-red-400">Sold Out</p>
              )}
            </div>
          </div>
        )}

        {/* General Admission Section */}
        <div className="bg-gray-700 p-6 rounded-lg">
          <div className="flex flex-col space-y-4">
            <div className="flex flex-col md:flex-row md:justify-between md:items-center">
              <div>
                <h3 className="text-2xl font-bold text-white">General Admission</h3>
                {event.ticket_description_general && (
                  <p className="text-gray-400 italic mt-1">{event.ticket_description_general}</p>
                )}
              </div>
              <div className="flex items-center gap-4 mt-4 md:mt-0">
                <span className="text-2xl font-bold text-white">${event.price_general_admission}</span>
                <div className="flex items-center gap-4">
                  <Button
                    variant="outline"
                    size="icon"
                    onClick={() => onStandingTicketChange(false)}
                    disabled={standingTickets === 0}
                  >
                    <Minus className="h-4 w-4" />
                  </Button>
                  <span className="text-2xl font-bold text-white min-w-[3ch]">
                    {standingTickets}
                  </span>
                  <Button
                    variant="outline"
                    size="icon"
                    onClick={() => onStandingTicketChange(true)}
                    disabled={!maxStandingTickets || standingTickets >= maxStandingTickets}
                  >
                    <Plus className="h-4 w-4" />
                  </Button>
                </div>
              </div>
            </div>
            {maxStandingTickets === 0 && (
              <p className="text-sm text-red-400">Sold Out</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};